import { Box, Tooltip, useTheme } from '@mui/material'
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined'
import { C100Row } from '../../_types/carnivore100.type'
import {
  downloadCsv, exportFileName, publishedOn, tickerCsv
} from '../../pages/carnivore100/carnivore100.export'
import { c100Tokens } from './c100-tokens'

const MONO = "'IBM Plex Mono', monospace"

// Exports exactly what the table is showing — filters, search and sort all
// carry through — so the file matches the screen the user is looking at rather
// than silently shipping names they filtered out.
export default function ExportButton({
  rows,
  updatedAt
}: {
  rows: C100Row[]
  updatedAt?: string
}) {
  const theme = useTheme()
  const t = c100Tokens(theme)
  const fileName = exportFileName(publishedOn(updatedAt))
  const disabled = rows.length === 0

  return (
    <Tooltip
      title={disabled ? 'Nothing to export' : `${rows.length} tickers · ${fileName}`}
      arrow
    >
      {/* span keeps the tooltip alive while the button is disabled */}
      <Box component="span" sx={{ flexShrink: 0 }}>
        <Box
          component="button"
          disabled={disabled}
          aria-label="Export tickers as CSV"
          onClick={() => downloadCsv(fileName, tickerCsv(rows))}
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 0.75,
            width: { xs: '100%', sm: 'auto' },
            justifyContent: 'center',
            whiteSpace: 'nowrap',
            fontFamily: MONO,
            fontSize: 11,
            fontWeight: 600,
            letterSpacing: '0.08em',
            textTransform: 'uppercase',
            color: disabled ? t.muted : t.accent,
            bgcolor: disabled ? 'transparent' : t.faintAccentBg,
            border: `1px solid ${disabled ? t.hairline : t.accent}`,
            borderRadius: 999,
            cursor: disabled ? 'default' : 'pointer',
            px: 1.75,
            py: 0.75,
            transition: 'background-color .15s, color .15s',
            '&:hover': disabled ? {} : { bgcolor: t.accent, color: '#fff' }
          }}
        >
          <FileDownloadOutlinedIcon sx={{ fontSize: 15 }} />
          Export CSV
        </Box>
      </Box>
    </Tooltip>
  )
}
